import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

import photo1 from "@/assets/photo-1.jpg.asset.json";
import photo2 from "@/assets/photo-2.jpg.asset.json";
import photo4 from "@/assets/photo-4.jpg.asset.json";
import photo5 from "@/assets/photo-5.jpg.asset.json";
import photo6 from "@/assets/photo-6.jpg.asset.json";
import photo7 from "@/assets/photo-7.jpg.asset.json";
import photo8 from "@/assets/photo-8.jpg.asset.json";
import photo37 from "@/assets/photo-37.jpg.asset.json";
import photo39 from "@/assets/photo-39.jpg.asset.json";
import photo40 from "@/assets/photo-40.jpg.asset.json";
import photo41 from "@/assets/photo-41.jpg.asset.json";
import photo42 from "@/assets/photo-42.jpg.asset.json";
import photo43 from "@/assets/photo-43.jpg.asset.json";
import photo44 from "@/assets/photo-44.jpg.asset.json";
import photo45 from "@/assets/photo-45.jpg.asset.json";
import photo46 from "@/assets/photo-46.jpg.asset.json";
import photo47 from "@/assets/photo-47.jpg.asset.json";
import photo48 from "@/assets/photo-48.jpg.asset.json";
import photo49 from "@/assets/photo-49.jpg.asset.json";
import photo50 from "@/assets/photo-50.jpg.asset.json";
import photo52 from "@/assets/photo-52.jpg.asset.json";
import photo53 from "@/assets/photo-53.jpg.asset.json";

const PHOTOS = [
  photo1, photo2, photo4, photo5, photo6, photo7, photo8,
  photo37, photo39, photo40, photo41, photo42, photo43, photo44,
  photo45, photo46, photo47, photo48, photo49, photo50, photo52, photo53,
];

function pickPhoto(seed: string) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  return PHOTOS[Math.abs(hash) % PHOTOS.length];
}

export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function ImagePlaceholder({
  label = "Elektriker på arbejde",
  className = "",
  ratio = "aspect-[16/9]",
  src,
}: {
  label?: string;
  className?: string;
  ratio?: string;
  src?: string;
}) {
  const photo = src ?? pickPhoto(label).url;
  return (
    <div
      className={`relative w-full overflow-hidden rounded-2xl border border-border bg-secondary ${ratio} ${className}`}
    >
      <img
        src={photo}
        alt={label}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
  );
}
